









































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from '@/store/entities/page-request'
import CreateSession from "../../../store/entities/createhandoversession";
import PackageInfo from "../../../store/entities/handoversessionpackageinfo";
import HandoverSessionDetail from "@/store/entities/handover-session-detail-for-update";
import ListMixin from "@/components/mixin/handover-session-package-mixin";
import { mixins } from "vue-class-component";
import packageColumns from './handoversession-package-columns'
import _ from 'lodash';    
import AppConsts from "../../../lib/appconst";
import util from "../../../lib/util";
 class  PageUpdateSessionRequest extends PageRequest{
        uncompletedObjectOnly: boolean=false;
        keyword: string="";
}
@Component
export default class UpdateHandoverSession extends mixins(ListMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "handoverSessionPackages";
  session: HandoverSessionDetail = new HandoverSessionDetail();
  id: number=0;
  pagerequest:PageUpdateSessionRequest=new PageUpdateSessionRequest();
  code: string="";
  itemTypeCode :string ="";
  spinShow:boolean = false;

  get store() {
    return this.$store.state.handoverSessionPackages;
  }
  onGoBack(){
          this.$root.$router.push({name: 'handoversession'});
  }
  canUpdate()
  {
      return this.store.deliveryPackages.length>0  && !this.session.transferred;
  }
  async scancode()
  {
    this.spinShow = true;
    try {
        var code = this.code;
        this.code = "";
        await this.getItems(this.session.id,code,this.session.refCode,this.session.refTypeCode, this.itemTypeCode);
        this.spinShow = false;
    } catch (error) {
        this.spinShow = false;
    }
  }
  async save() {
    this.$Modal.confirm({
          title:this.L('Tips'),
          content:this.L('Confirm.UpdateHandoverSession'),
          okText:this.L('Yes'),
          cancelText:this.L('No'),
          onOk:async()=>{
              this.spinShow = true;
              try {
                  var deliveryPackageCodes = this.store.deliveryPackages.map((item) => item.packageNo);

                  var data = {
                      id : this.session.id,
                      refCode : this.session.refCode,
                      itemType: this.itemTypeCode,
                      note: this.session.note,
                      deliveryPackageCodes : deliveryPackageCodes
                  };
                  await this.$store.dispatch({
                    type: "handoverSession/update",
                    data: data
                  }) 
                  .then(result => {
                    Util.showSuccessMsg(this,"Success.UpdateHandoverSession");
                    this.reset();
                    this.refreshPage();
                  });
                  this.spinShow = false;
              } catch (error) {
                  this.spinShow = false;
              }
          }
    });
       
  }
  reset()
  {
    this.pagerequest = new PageUpdateSessionRequest();
    this.code="";
    this.$store.commit({
      type: "handoverSessionPackages/resetList"
    });
  }
  async refreshPage() {
      await this.$store
        .dispatch({
          type: "handoverSession/getForUpdate",
          data: { id: this.id }
        })
        .then(result => {
          this.session = result;
          this.id = this.session.id;
          this.itemTypeCode = this.session.itemType;
          this.pushAndOrderPackages(result.items);
        });
  }
 
 columns= [
    ...packageColumns
    ,{
        title: Util.L('HandoverTime'),
        key:'handoverTime',
        render:(h:any,params:any)=>{
            if(Util.isNull(params.row.handoverTime))
              return h("span", "");
            return h("span", Util.toViewDateString(params.row.handoverTime));
        }
    }
    ,{
        title: Util.L('Action'),
        slot: 'action',
        align: 'center',
        width: 100
    }]
  async created(){
    this.spinShow = true;
    try {
        this.reset();
        this.id = +this.$root.$router.currentRoute.params.id;
        await this.refreshPage();
        this.spinShow = false;
    } catch (error) {
        this.spinShow = false;
    }
  }
}
